import {
  _30_MIN_INDIVIDUAL_90832,
  DIAGNOSTIC_INTERVIEW_90791,
  DIAGNOSTIC_INTERVIEW_90792,
} from "@/components/Provider/ScheduleAvailability/constants";

export const providerTypeToDefaultEvent = (provider: { provider_type?: string }): string => {
  switch (provider.provider_type) {
    case "BEHAVIORAL":
      return _30_MIN_INDIVIDUAL_90832;

    case "BEHAVIORAL_INTAKE":
      return DIAGNOSTIC_INTERVIEW_90791;

    case "PRESCRIBE":
      return DIAGNOSTIC_INTERVIEW_90792;

    default:
      return _30_MIN_INDIVIDUAL_90832;
  }
};
